// extracted by mini-css-extract-plugin
module.exports = {"banner":"SocialBanner__banner___1dOkg","header":"SocialBanner__header___1htvM","p":"SocialBanner__p___-WR8Y","socialMediaImg":"SocialBanner__socialMediaImg___1YMK4"};